import script from "./OptionsView.vue?vue&type=script&lang=ts&setup=true"
export * from "./OptionsView.vue?vue&type=script&lang=ts&setup=true"

import "./OptionsView.vue?vue&type=style&index=0&id=742a890d&lang=scss"

const __exports__ = script;

export default __exports__